/* eslint-disable @typescript-eslint/naming-convention */
import { z } from 'zod';
import { addressSchema } from '../common/addressSchema';
import { getProviderValidation, applyProviderNameValidation } from './providerValidations';

function createBaseSchema(provider?: string) {
    const providerValidation = getProviderValidation(provider);

    const firstNameSchema = applyProviderNameValidation(
        z.string({ required_error: 'Enter your first name' }).min(1, {
            message: 'Enter your first name',
        }),
        providerValidation?.firstName,
    );

    const lastNameSchema = applyProviderNameValidation(
        z.string({ required_error: 'Enter your last name' }).min(1, {
            message: 'Enter your last name',
        }),
        providerValidation?.lastName,
    );

    return z.object({
        firstName: firstNameSchema,
        lastName: lastNameSchema,
        email: z
            .string({ required_error: 'Does not match format: example@email.com' })
            .email({ message: 'Does not match format: example@email.com' }),
        primaryPhone: z
            .string({ required_error: 'Does not match phone format: (xxx) xxx-xxxx' })
            .regex(/^((\d{3}\-|\(\d{3}\)\s)\d{3}-\d{4}|\d{10})$/, {
                message: 'Does not match phone format: (xxx) xxx-xxxx',
            }),
        address: addressSchema.optional(),
    });
}

export const createSchema = (isPrequalification: boolean = false, provider?: string) => {
    const baseSchema = createBaseSchema(provider);

    if (isPrequalification) {
        return baseSchema.extend({
            ssnLast4: z
                .string({ required_error: 'SSN last 4 digits are required for prequalification' })
                .length(4, { message: 'SSN last 4 digits must be exactly 4 digits' })
                .regex(/^\d{4}$/, { message: 'SSN last 4 digits must contain only numbers' }),
        });
    }

    return baseSchema.extend({
        ssnLast4: z.string().optional(),
    });
};

// Export the default schema for backward compatibility
export const schema = createSchema();

export type ExternalApplicationData = z.infer<typeof schema>;
